/* eslint-disable import/no-unused-modules */
import { useReducer } from 'react';
import reducer, { generateInitialState } from './reducer';
import useModalHandler from './hooks/useModalHandler';
import Modal from 'modals/Modal';
import ContextHooksWrapper from './ContextHooksWrapper';

const FiltersProvider = ({ children, Context, withInitialFilters = true }) => {
  const [state, dispatch] = useReducer(reducer, generateInitialState());

  const modalHandler = useModalHandler();

  return (
    <Context.Provider value={{ state, dispatch, modalHandler }}>
      <ContextHooksWrapper
        Context={Context}
        withInitialFilters={withInitialFilters}
      />

      {children}
      <Modal {...modalHandler.modalConfig} />
    </Context.Provider>
  );
};

export default FiltersProvider;
